"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateInventoryReducer = exports.fetchLatestInventoryReducer = exports.updateInventorySlice = exports.fetchLatestInventorySlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const inventoryAction_1 = require("./inventoryAction");
const fetchLatestInventoryInitialState = {
    loading: false,
    error: null,
    data: [],
};
const updateInitialState = {
    loading: false,
    error: null,
    data: [],
};
exports.fetchLatestInventorySlice = (0, toolkit_1.createSlice)({
    name: "inventory/fetchLatestInventory",
    initialState: fetchLatestInventoryInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(inventoryAction_1.fetchLatestInventory.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        });
        builder.addCase(inventoryAction_1.fetchLatestInventory.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(inventoryAction_1.fetchLatestInventory.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    },
});
exports.updateInventorySlice = (0, toolkit_1.createSlice)({
    name: "inventory/update",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(inventoryAction_1.update.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        });
        builder.addCase(inventoryAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(inventoryAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchLatestInventoryReducer = exports.fetchLatestInventorySlice.reducer;
exports.updateInventoryReducer = exports.updateInventorySlice.reducer;
